import { api } from '../../../shared/services/api/client';
import { createLogger } from '../../../shared/config/logger';
const log = createLogger('scan_api.js');

export const scanQRCodeCustomerPass = (passId) => {
    log.info('scanQRCodeCustomerPass called', { passId });
    return api.get(`/merchant/customer-passes/${passId}`);
};

export const scanCustomerPassEmail = (customerLookup) => {
    log.info('scanCustomerPassEmail called', { customerLookup });
    // Using query param for customer lookup (email or phone)
    return api.get('/merchant/customer-passes', {
        params: { lookup: customerLookup }
    });
};

export const getAllCustomerPasses = () => {
    log.info('getAllCustomerPasses called');
    return api.get('/merchant/customer-passes');
};

export const updateCustomerPoints = (passId, newPoints, addVisit, moneySpent) => {
    log.info('updateCustomerPoints called', { passId, newPoints, addVisit, moneySpent });
    return api.patch(`/merchant/customer-passes/${passId}/points`, {
        newPoints,
        addVisit,
        moneySpent,
    });
};

export const checkCustomerRewardEligibility = (passId) => {
    log.info('checkCustomerRewardEligibility called', { passId });
    return api.post('/merchant/rewards/check-eligibility', {
        passId,
    });
};

export const redeemCustomerReward = (customerEmail, rewardId, passId) => {
    log.info('redeemCustomerReward called', { customerEmail, rewardId, passId });
    return api.post(`/merchant/rewards/${rewardId}/redeem`, {
        customerEmail,
        passId,
    });
};
